import React, { useEffect, useRef } from 'react';

import AOS from 'aos';
import 'aos/dist/aos.css';

function Avatar() {
  const profileImage = '/Image/profile.JPG';
  const VectorImage = '/Image/Vector.png';
  AOS.init();

  const rightPicRef = useRef(null);
  const leftPicRef = useRef(null);
  const vectorPicRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const value = window.scrollY;

      if (window.innerWidth > 768) { 
      rightPicRef.current.style.transform = `translateX(${value / 1.5}px)`;  
      leftPicRef.current.style.transform = `translateX(-${value / 1.5}px)`; 

      const rotationAngle = value / 2.5; 
      vectorPicRef.current.style.transform = `translateX(${value / 3}px) translateY(-${value / 1.5}px) rotate(${rotationAngle}deg)`;
    }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className='flex justify-center my-10'>
      <img src={profileImage} className="hidden md:flex relative w-80 h-80  mt-56 rounded-full z-40 bg-cover"/>
      <div ref={rightPicRef} className='hidden md:flex absolute  mt-60 transform -translate-x-8 w-80 h-80 rounded-full bg-[#1501FF]'>
      <p className='font-bold text-3xl text-white uppercase absolute left-20 -top-16 md:left-20  w-52 h-52  mt-52'>developer</p>
      </div>
      <div ref={leftPicRef} className='hidden md:flex absolute  mt-60 transform translate-x-10 w-80 h-80 rounded-full bg-[#D5FF3C]'>
        <p className='font-bold text-3xl uppercase text-zinc-700 absolute left-20 -top-16 md:left-20  w-52 h-52  mt-52'>Front end</p>
      </div>
      <div ref={vectorPicRef} className="absolute left-36 -top-20 lg:-top-1 w-60 h-60 -rotate-45 mt-72 z-40">
        <img src={VectorImage} />
        <p className='font-bold text-zinc-700 uppercase absolute left-20 -top-32 md:left-20  w-52 h-52  mt-52 z-40 '>react <br /> library</p>
      </div>
      <img src={profileImage} className="flex md:hidden w-80 h-[600px]  mt-56 rounded-full z-30" data-aos="fade-up" data-aos-duration="2000" />
    </div>
  )
}

export default Avatar;

